// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__iYVHA","container":"styles_container__9mgi1","submitButton":"styles_submitButton__UkfLw"};